import { AxiosResponse } from "axios";
import { ActionTree } from "vuex";
import { IProductionLineState } from "./state";
import {
    ADD_PRODUCTION_LINES,
    ADD_WORK_ORDERS,
    DELETE_NOTIFICATION,
    SET_LAST_CLEANINGS,
} from "./mutations-types";
import { apiClient, apiJdeClient } from "@/services";
import { IProductionLine, IWorkOrder, ICleaning } from "@/models";
import moment from "moment";

export const actions: ActionTree<IProductionLineState, number> = {

    async fetchProductionLines(context): Promise<AxiosResponse<IProductionLine[]>> {
        const response = await apiClient.get<IProductionLine[]>(`/productionlines`);
        context.commit(ADD_PRODUCTION_LINES, response.data);

        return response;
    },

    async synchronizeWorkOrders(context): Promise<AxiosResponse<void>> {
        const response = apiJdeClient.post("/SynchronizeWorkOrdersFunction", {});

        return response;
    },

    async fetchWorkOrders(context): Promise<AxiosResponse<IWorkOrder[]>> {
        const today = moment();
        const response = await apiClient.get<IWorkOrder[]>(`/workorders/workordersoftheday/${today.toISOString(false)}`);
        context.commit(ADD_WORK_ORDERS, response.data);

        return response;
    },

    async fetchLastCleanings(context): Promise<AxiosResponse<ICleaning[]>> {
        const response = await apiClient.get<ICleaning[]>(`/cleanings/getlastcleanings`);
        context.commit(SET_LAST_CLEANINGS, response.data);

        return response;
    },

    async startWorkOrder(context, workOrderId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workorders/${workOrderId}/start`);
        return response;
    },

    async returnWorkOrder(context, workOrderId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workorders/${workOrderId}/return`);
        return response;
    },

    async finishWorkOrder(context, workOrderId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workorders/${workOrderId}/finish`);
        return response;
    },

    async storeWorkOrder(context, workOrderId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workorders/${workOrderId}/store`);
        return response;
    },

    async cancelStoreWorkOrder(context, workOrderId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workorders/${workOrderId}/cancelstore`);
        return response;
    },

    async supplyWorkOrderComponent(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workordercomponents/${data.workOrderComponentId}/supply/${data.quantity}`);
        return response;
    },

    async returnWorkOrderComponent(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workordercomponents/${data.workOrderComponentId}/return/${data.quantity}`);
        return response;
    },

    async addWorkOrderComment(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workordercomments/add`, data);
        return response;
    },

    async addWorkOrderMission(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workordermissions/add`, data);
        return response;
    },

    async assigneWorkOrderMission(context, workOrderMissionId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workordermissions/${workOrderMissionId}/assigne`);
        return response;
    },

    async cancelWorkOrderMission(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/workordermissions/${data.workOrderMissionId}/cancel/${data.cancelReason}`);
        return response;
    },

    async cancelSupply(context, supplyId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/supplies/${supplyId}/cancel`);
        return response;
    },

    async uncancelSupply(context, supplyId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/supplies/${supplyId}/uncancel`);
        return response;
    },

    async commentSupply(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/supplies/${data.supplyId}/comment/${data.comment}`);
        return response;
    },

    async editSupplyQuantity(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/supplies/${data.supplyId}/editQuantity/${data.quantity}`);
        return response;
    },

    deleteNotification(context, index: number): void {
        context.commit(DELETE_NOTIFICATION, index);
    },

    async addCleaning(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/cleanings/add`, data);
        return response;
    },

    async addCountPallets(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/counts/addcountpallets`, data);
        return response;
    },

    async addCcountConsumables(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/counts/addcountconsumables`, data);
        return response;
    },

    async cancelReturn(context, returnId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/returns/${returnId}/cancel`);
        return response;
    },

    async uncancelReturn(context, returnId: number): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/returns/${returnId}/uncancel`);
        return response;
    },

    async commentReturn(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/returns/${data.returnId}/comment/${data.comment}`);
        return response;
    },

    async editReturnQuantity(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/returns/${data.returnId}/editQuantity/${data.quantity}`);
        return response;
    },

};
